import { CwtApiSchema, CwtModel, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { EvaluationResultEntity } from "./eval-result.entity";

export type MorphologyFace = 'front' | 'back';
export type PainLevel = 'low' | 'medium' | 'high';
export type PainSize = 'small' | 'medium' | 'large';
export type PainArea = 'head' | 'back' | 'torso' | 'upper' | 'lower';

export type PainPointConfig = {
    level: PainLevel; 
    size: PainSize;
}

@CwtSchema()
export class PainPoint extends CwtApiSchema {
    @CwtProp() x: number;
    @CwtProp() y: number;
    @CwtProp() level: PainLevel;
    @CwtProp() size: PainSize;
    @CwtProp() area: PainArea;
}

@CwtSchema()
export class EvalPhysicalResult extends CwtApiSchema {
    @CwtProp() practicedSport: string;
    @CwtProp() practicedSubSport: string;
    @CwtProp() practiceFrequency: string;
    @CwtProp() practiceDuration: string;
    @CwtProp() practiceLoad: string;
    @CwtProp() wellness: number;
    @CwtProp() recovery: number;
    @CwtProp() fatigue: number;
    @CwtProp({ ref: PainPoint }) frontPainPoints: PainPoint[];
    @CwtProp({ ref: PainPoint }) backPainPoints: PainPoint[];
    @CwtProp() fatigueAndPainFactors: string[];
}

@CwtModel({ name: 'eval-physical' })
export class EvalPhysical extends EvaluationResultEntity {
    @CwtProp() painScore: number;
    @CwtProp() wellnessScore: number;
    @CwtProp() recoveryScore: number;
    @CwtProp() fatigueScore: number;
    @CwtProp({ ref: EvalPhysicalResult }) result: EvalPhysicalResult;
}